import { getSubOption, mapSubcategoryToActivities } from 'data/filters';
import { useState } from 'react';

const getSubcategoriesFilters = (buckets, subcategoryMap) =>
  Object.keys(subcategoryMap)
    .map((key) => getSubOption('subcategory.items[]', key))
    .filter((subCategory) =>
      buckets.some(
        ({ key }) =>
          key === subCategory?.queryValue || key === subCategory.value,
      ),
    );

function useActivitiesFilter(initialSelectedFilters, aggregations) {
  const hasActivityFilter =
    initialSelectedFilters
      ?.find((filter) => filter.uid === 'activityType.activity')
      ?.subOptions.some((subCategory) => subCategory.value === 'activities') ||
    false;

  const subCategoryFilter = initialSelectedFilters?.find(
    (filter) => filter.uid === 'subcategory.items[]',
  );

  const activitiesFilter =
    subCategoryFilter?.subOptions
      ?.filter(({ value }) => value && mapSubcategoryToActivities[value])
      ?.map(({ value }) => value) || [];

  const activitySubcategoriesFilters = getSubcategoriesFilters(
    aggregations?.global?.location_filtered?.subcategories?.buckets || [],
    mapSubcategoryToActivities,
  );

  const nrOfFiltersPossible = activitySubcategoriesFilters.length;

  const [activitiesOptions, setActivitiesOptions] =
    useState<string[]>(activitiesFilter);
  const [activitiesFilterStatus, setActivitiesFilterStatus] =
    useState(hasActivityFilter);

  const onToggleAllActivities = () => {
    setActivitiesOptions([]);
    setActivitiesFilterStatus(!activitiesFilterStatus);
  };

  const onToggleActivities = (value: string) => {
    if (activitiesOptions.includes(value)) {
      setActivitiesOptions(
        (prevDuration) => prevDuration.filter((item) => item !== value) || [],
      );
      setActivitiesFilterStatus(false);
    } else {
      if (activitiesOptions.length + 1 === nrOfFiltersPossible) {
        setActivitiesOptions([]);
        setActivitiesFilterStatus(true);
      } else {
        setActivitiesOptions((prevDuration) => [...prevDuration, value]);
        setActivitiesFilterStatus(false);
      }
    }
  };

  return {
    activitiesOptions,
    activitiesFilterStatus,
    onToggleActivities,
    onToggleAllActivities,
  };
}

export default useActivitiesFilter;
